import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showShareByTextModal } from 'actions/modal';
import { sendInviteSMSByWAId, getWAURLTextTemplate } from 'actions/waitingArea';
import { displayGlobalMessage } from 'actions/globalMessage';
import { Container, Button } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';

export default function RightPanelTop(props) {
  const dispatch = useDispatch();
  let [sendingText, setSendingText] = useState(false);
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  saveClasses =
    props.formik.errors.mobile ||
    props.formik.values.mobile === '' ||
    props.additionalTextMessage.toString().length > props.textMessageCharacterLimit ||
    !props.textMessageValidState.valid
      ? saveClasses + ' disabled'
      : saveClasses;

  const sendTextMessage = () => {
    if (
      props.formik.errors.mobile ||
      props.formik.values.mobile === '' ||
      !props.textMessageValidState.valid ||
      sendingText
    ) {
      return;
    }
    let cb = (result, err) => {
      if (result) {
        setSendingText(false);
        dispatch(showShareByTextModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ShareURL.SMSSuccessMsg,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      } else {
        setSendingText(false);
        if (err === 'InvalidRecipient') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.Errors.NoValidPhoneNumber,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err === 'AdditionalMessageNotAllowed') {
          dispatch(showShareByTextModal(false));
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.StaffAdditionalMessageNotAllowed,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.TryAgain,
              gotItCallBack: () => {
                dispatch(
                  getWAURLTextTemplate(props.waitingArea.id, () => {
                    dispatch(showShareByTextModal(true));
                  })
                );
              },
            })
          );
        }
      }
    };
    setSendingText(true);
    let phoneNumber = props.formik.values.mobile;
    let payload = {
      additionalMessage: props.allowEdit ? props.additionalTextMessage : '',
      recipient: phoneNumber,
    };
    sendInviteSMSByWAId(props.waitingArea.id, payload, cb);
  };

  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        <div className="ui actions mrbl max-width">
          <Button
            tabIndex="3"
            type="button"
            data-group="updatewaitingAreaForm"
            className={sendingText ? saveClasses + ' loading' : saveClasses}
            onClick={sendTextMessage}
          >
            {APP.LANGUAGE.ShareURL.SendMessage}
            <i className="send icon" />
          </Button>
          <button
            tabIndex="4"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
            onClick={() => dispatch(showShareByTextModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="display-flex mrts mrbs max-width pdlm pdrm">
          <Button
            tabIndex="3"
            type="button"
            data-group="updatewaitingAreaForm"
            className={(sendingText ? saveClasses + ' loading' : saveClasses) + ' mrrm'}
            onClick={sendTextMessage}
          >
            {APP.LANGUAGE.ShareURL.SendMessageMobile}
            <i className="send icon" />
          </Button>
          <button
            tabIndex="4"
            type="button"
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull"
            onClick={() => dispatch(showShareByTextModal(false))}
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      </Container>
    </React.Fragment>
  );
}
